import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';
import type { ShipmentTypeDescription } from '../../types';

export interface GetShipmentDashboardRequestParams {
  ResultType: string;
  CustomerKey: number;
  StartDate: string;
  EndDate: string;
}

export const getShipmentDashboardAPI = (params: GetShipmentDashboardRequestParams) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentDashboard`,
    method: 'get',
    params,
  });
};

export type ShipmentDashboardResponse = {
  totalNumberOfShipments: number;
  carrierkey: number;
  transportationProviderName: string;
  cargoType: string;
  shipmentStatus: string;
  shipmentType: ShipmentTypeDescription;
  month: string;
  carrierScacCode: string;
}[];

export const fetchShipmentDashboard = async (
  params: GetShipmentDashboardRequestParams,
): Promise<ShipmentDashboardResponse> => {
  const response: AxiosResponse<ShipmentDashboardResponse> = await getShipmentDashboardAPI(params);
  return response.data;
};
